<div class="numeric-wrapper">
  <button kendoButton (click)="decrement()" themeColor="primary" size="large" class="numeric-button">&nbsp;&nbsp;–&nbsp;&nbsp;</button>
  <kendo-textbox
    fillMode="flat"
    size="large"
    [placeholder]="value.toString()"
    [(ngModel)]="value"
    (input)="allowOnlyNumbers($event)"
  ></kendo-textbox>
  <button kendoButton (click)="increment()" themeColor="primary" size="large" class="numeric-button">&nbsp;&nbsp;+&nbsp;&nbsp;</button>
</div>
